export function cookieExist(cookieName: string): boolean {
  const a = `; ${document.cookie}`.match(`;\\s*${cookieName}=([^;]+)`);
  return !(a == null);
}

export function getCookie(cookieName: string): string {
  const regExp = RegExp(`;\\s*${cookieName}=([^;]+)`, 'g');
  const iterator = Array.from(`; ${document.cookie}`.matchAll(regExp) || []);
  const a = iterator.length ? iterator[iterator.length - 1] : [];
  return a.length > 1 ? a[1] : '';
}

export function deleteCookie(cookieName: string, options?: { domain?: string }): void {
  try {
    const domain = options?.domain;
    document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 GMT${domain ? `;domain=${domain};` : ';'}path=/`;
  } catch (e) {
    console.error(e);
  }
}

export function setCookie(cookieName: string, cookieValue: string | number, options?: { cookieExpiryTime?: string; cookieDomain?: string }): void {
  let prettyCookie = '';
  try {
    let cookie = `${cookieName}=${cookieValue}`;
    if (options?.cookieExpiryTime) {
      cookie += `;expires=${options?.cookieExpiryTime}`;
    }
    if (options?.cookieDomain) {
      cookie += `;domain=${options?.cookieDomain}`;
    }
    cookie += ';path=/';
    prettyCookie = cookie.replace(`${cookieName}=`, `%c${cookieName}%c=`);
    document.cookie = cookie;
  } catch (e) {
    console.error(e, '\n\n🍪 ✘ Cookie not added:\n' + prettyCookie, 'font-weight: bold', 'font-weight: normal');
  }
}

